import Modal from '@components/v2/ui/Modal/Modal';
import type { ModalFooterConfig } from '@components/v2/ui/Modal/modal.types';
import LangEnum from '../../lang/LangEnum';
import { StoreSignUpTestIds } from '../../utils/testIds/storeSignUp.testIds';
import { useTranslation } from '../translation/TranslationContext';
import LocationAndCnpjStep from './LocationAndCnpjStep';
import { SignUpContextProvider, useSignUpContext } from './SignUp.context';
import StoreStep from './StoreStep';
import UserStep from './UserStep';
import { SignUpSteps } from './types/signUp.types';

const SignUp = () => {
  const { state, handleChangeStep, submitCurrentStep, isStepSubmitting } = useSignUpContext();
  const { translate } = useTranslation();
  const isWizardOpen = state.currentStep !== SignUpSteps.LOCATION_AND_CNPJ;

  const resolveFooter = (): ModalFooterConfig | undefined => {
    if (state.currentStep === SignUpSteps.STORE) {
      return {
        secondaryAction: {
          label: translate(LangEnum.GLOBAL_CANCEL_LABEL),
          onClick: () => handleChangeStep(SignUpSteps.LOCATION_AND_CNPJ),
        },
        primaryAction: {
          label: translate(LangEnum.GLOBAL_CONTINUE),
          onClick: submitCurrentStep,
          isLoading: isStepSubmitting,
          isDisabled: isStepSubmitting,
          testId: StoreSignUpTestIds.WIZARD_CONTINUE_BUTTON,
        },
      };
    }

    return {
      secondaryAction: {
        label: translate(LangEnum.GLOBAL_GO_BACK),
        onClick: () => handleChangeStep(SignUpSteps.STORE),
      },
      primaryAction: {
        label: translate(LangEnum.SIGN_UP_FINISH_REGISTRATION),
        onClick: submitCurrentStep,
        isLoading: isStepSubmitting,
        isDisabled: isStepSubmitting,
        testId: StoreSignUpTestIds.FINISH_REGISTRATION_BUTTON,
      },
    };
  };

  const footer = resolveFooter();

  return (
    <>
      <LocationAndCnpjStep />
      <Modal
        isOpen={isWizardOpen}
        size="expanded"
        isDismissable={false}
        header={{ title: translate(LangEnum.SIGN_UP_MODAL_TITLE) }}
        footer={footer}
        onClose={() => handleChangeStep(SignUpSteps.LOCATION_AND_CNPJ)}
      >
        {state.currentStep === SignUpSteps.STORE && <StoreStep />}
        {state.currentStep === SignUpSteps.USER && <UserStep />}
      </Modal>
    </>
  );
};

const SignUpPage = () => (
  <SignUpContextProvider>
    <SignUp />
  </SignUpContextProvider>
);

export default SignUpPage;
